{
  "codexEntityForm": {
    "character": "Karakter",
    "place": "Mekân",
    "faction": "Hizip",
    "object": "Nesne",
    "concept": "Kavram",
    "editName": "Düzenle: {{name}}",
    "newCodexEntry": "Yeni Kodeks kaydı",
    "theWorldHasChangedTheDraft": "Dünya değişti. Taslak saklandı; kaydetmeden önce kaydı yeniden yükle.",
    "portraitChooseAnImage": "Portre: bir görsel seç",
    "change": "Değiştir",
    "addPortrait": "Portre ekle",
    "portraitImage": "Portre görseli",
    "entryName": "Kayıt adı",
    "name": "Ad",
    "entryType": "Kayıt türü",
    "customCategory": "Özel kategori",
    "categoryEGDeityShipSpell": "Kategori, örn. Tanrı, Gemi, Büyü",
    "aliases": "Takma adlar",
    "entryAliases": "Kayıt takma adları",
    "otherNamesOneAtATime": "Diğer adlar, tek tek…",
    "tags": "Etiketler",
    "entryTags": "Kayıt etiketleri",
    "themesRolesArcs": "Temalar, roller, yaylar…",
    "collection": "Koleksiyon",
    "entryCollection": "Kayıt koleksiyonu",
    "noCustomCollection": "Özel koleksiyon yok",
    "folder": "Klasör",
    "entryFolder": "Kayıt klasörü",
    "unfiled": "Klasörsüz",
    "notes": "Notlar",
    "entryNotes": "Kayıt notları",
    "whoTheyAreWhatTheyWant": "Kim oldukları, ne istedikleri, okurun asla çok erken öğrenmemesi gerekenler…",
    "entryFields": "Kayıt alanları",
    "fields": "Alanlar",
    "fieldTemplate": "Alan şablonu",
    "template": "Şablon…",
    "schemaOf": "Şunun şeması:",
    "addMissingFields": "Eksik alanları ekle",
    "addField": "Alan ekle",
    "noCustomFieldYetFieldsGive": "Henüz özel alan yok. Alanlar bir kayda Kontroller'in üzerinde akıl yürütebileceği düzenli olgular verir: yaş, bağlılık, bir sır.",
    "sharedFieldNamesTypesAndOptions": "Ortak alan adları, türleri ve seçenekleri koleksiyon ayarlarında yönetilir. Değerler bu sayfaya aittir.",
    "fieldNameN": "Alan adı {{n}}",
    "fieldName": "Alan adı",
    "fieldTypeN": "Alan türü {{n}}",
    "unknown": "Bilinmiyor",
    "fieldValueN": "Alan değeri {{n}}",
    "select": "Seç…",
    "yes": "Evet",
    "no": "Hayır",
    "value": "Değer",
    "chooseAnEntry": "Bir kayıt seç…",
    "eGSpringOfYear12": "örn. 12. yılın baharı ya da kuşatma günü",
    "below": "Aşağıda",
    "unknownValueN": "Bilinmeyen değer {{n}}",
    "required": "Zorunlu",
    "sharedField": "Ortak alan",
    "remove": "Kaldır",
    "confirmRemoval": "Kaldırmayı onayla",
    "paragraph": "Paragraf",
    "aFewLines": "Birkaç satır…",
    "discardTheDraft": "Taslak atılsın mı?",
    "confirmReload": "Yeniden yüklemeyi onayla",
    "keepEditing": "Düzenlemeye devam et",
    "reloadEntry": "Kaydı yeniden yükle",
    "cancel": "İptal",
    "chooseAnImageFileForThe": "Portre için bir görsel dosyası seç.",
    "thePortraitMustBeUnder8": "Portre 8 MiB'ın altında olmalı.",
    "saveEntry": "Kaydı kaydet",
    "searchEntries": "Kayıtlarda ara…"
  },
  "codexEntryDialog": {
    "newCodexEntry": "Yeni Kodeks kaydı",
    "savedToWorldCodexTheManuscript": "Dünya › Kodeks'e kaydedildi; metin, yazdığın yerde ondan söz edecek.",
    "createAndMention": "Oluştur ve an"
  },
  "continuityPanel": {
    "relationsOverTime": "Zaman içinde ilişkiler",
    "checkingRelations": "İlişkiler kontrol ediliyor…",
    "cancel": "İptal",
    "theProjectHasChangedRunThe": "Bu çalıştırmadan sonra metin ya da dünya değişti. İlişkileri yenilemek için kontrolleri yeniden çalıştır.",
    "anAnalysisLimitWasReachedThe": "Bir analiz sınırına ulaşıldı. Sonuç kısmi.",
    "ruleApplied": "Kural: “{{label}}”, {{rule}}.",
    "oneSourcePerTarget": "her hedef için bir kaynak",
    "oneTargetPerSource": "her kaynak için bir hedef",
    "interval": "{{start}} ile {{end}} arası",
    "openScene": "Aç: {{scene}}",
    "findingReferenceMissing": "Artık var olmayan bir kayda işaret ediyor.",
    "findingConfirmedWithoutEvidence": "Metinden alıntı olmadan onaylandı, bu yüzden kaynağı kontrol edilemez.",
    "findingEvidenceMissing": "Dayandığı bir alıntı kayıp.",
    "findingEvidenceNotCurrent": "Dayandığı bir alıntı onaylanmamış ya da artık metinle uyuşmuyor.",
    "findingExclusiveNotEvaluable": "Kurala göre kontrol edilemez: bir yön, iki uç ve tam bir zaman aralığı gerekir.",
    "findingExclusiveOverlap": "Bunlardan ikisi aynı anda geçerli; kural buna izin vermiyor.",
    "findingOther": "Bu ilişkide kontrol edilecek bir şey var.",
    "theProjectExceedsTheLimitOf": "Proje bu analizin sınırını aşıyor. Hiçbir veri değişmedi.",
    "theAnalysisExceededItsExecutionLimit": "Analiz yürütme sınırını aştı. Hiçbir veri değişmedi.",
    "analysisCancelled": "Analiz iptal edildi.",
    "checksNotCompletedTheTextAnd": "Kontroller tamamlanmadı. Metin ve kanon değişmedi."
  },
  "eventTimelinePanel": {
    "eventHistory": "Olay geçmişi",
    "timeline": "Zaman çizelgesi",
    "newEvent": "Yeni olay",
    "searchEvents": "Olaylarda ara",
    "searchEvents2": "Olaylarda ara…",
    "timelineOrder": "Zaman çizelgesi sırası",
    "storyTime": "Hikâye zamanı",
    "readingOrder": "Okuma sırası",
    "dateStatus": "Tarih durumu",
    "allDates": "Tüm tarihler",
    "resolvedDates": "Çözümlenmiş tarihler",
    "unresolvedDates": "Çözümlenmemiş tarihler",
    "filterEventsByScene": "Olayları sahneye göre filtrele",
    "allScenes": "Tüm sahneler",
    "scenes": "Sahneler",
    "editEvent": "Olayı düzenle",
    "closeEventEditor": "Olay düzenleyicisini kapat",
    "theWorldHasChangedReloadThe": "Dünya değişti. Kaydetmeden önce olayı yeniden yükle; taslak alanlar saklandı.",
    "eventTitle": "Olay başlığı",
    "whatHappens": "Ne oluyor",
    "scene": "Sahne",
    "eventScene": "Olay sahnesi",
    "notLinked": "Bağlı değil",
    "removedSceneSceneid": "Kaldırılmış sahne — {{sceneId}}",
    "dateType": "Tarih türü",
    "eventDateType": "Olay tarih türü",
    "unknown": "Bilinmiyor",
    "definedInterval": "Tanımlı aralık",
    "relativeToAnEvent": "Bir olaya göre",
    "start": "Başlangıç",
    "eventStart": "Olay başlangıcı",
    "endExclusive": "Bitiş (hariç)",
    "eventEnd": "Olay bitişi",
    "referenceEvent": "Referans olay",
    "select": "Seç…",
    "referenceToVerifyAnchoreventid": "Doğrulanacak referans — {{anchorEventId}}",
    "events": "Olaylar",
    "offsetInTicks": "Tik cinsinden fark",
    "eventOffset": "Olay farkı",
    "saveEvent": "Olayı kaydet",
    "closeReload": "Kapat / yeniden yükle…",
    "discardTheDraftChanges": "Taslak değişiklikleri atılsın mı?",
    "discardDraft": "Taslağı at",
    "reloadEvent": "Olayı yeniden yükle",
    "keepEditing": "Düzenlemeye devam et",
    "noEventMatchesTheseFiltersEvents": "Bu filtrelerle eşleşen olay yok. Olaylar Kontroller'in üzerinde akıl yürüttüğü şeydir: bir şeyin ne zaman olduğu ve okurun bunu hangi sahnede öğrendiği.",
    "tickStart": "Tik {{start}}",
    "openScene": "Sahneyi aç",
    "editTitle": "Düzenle: {{title}}",
    "removeTitle": "Kaldır: {{title}}",
    "confirmEventRemoval": "Olay kaldırmayı onayla",
    "cancel": "İptal",
    "theWorldHasChangedCancelAnd": "Dünya değişti: iptal et ve onayı yeniden aç.",
    "resolvedDate": "Çözümlenmiş tarih",
    "unknownDate": "Bilinmeyen tarih",
    "missingReference": "Eksik başvuru",
    "timeCycle": "Zaman döngüsü",
    "dateOutOfRange": "Tarih aralık dışı",
    "eventsFoundOfTotal_one": "{{count}} olay bulundu · toplam {{total}}",
    "eventsFoundOfTotal_other": "{{count}} olay bulundu · toplam {{total}}",
    "removeThisEventReferences_one": "Bu olay kaldırılsın mı? {{count}} doğrudan başvurunun gözden geçirilmesi gerekecek.",
    "removeThisEventReferences_other": "Bu olay kaldırılsın mı? {{count}} doğrudan başvurunun gözden geçirilmesi gerekecek.",
    "showMoreEvents_one": "{{count}} olay daha göster",
    "showMoreEvents_other": "{{count}} olay daha göster"
  },
  "fieldEditor": {
    "choose": "Seç…",
    "labelSearch": "{{label}} araması",
    "search": "Ara…",
    "labelOptions": "{{label}} seçenekleri",
    "noMatch": "Eşleşme yok.",
    "optionsOnePerLine": "Seçenekler, her satırda bir tane",
    "fieldOptionsIndex": "Alan seçenekleri {{index}}",
    "addOptionIndex": "Seçenek ekle {{index}}",
    "newOption": "Yeni seçenek",
    "addOption": "Seçenek ekle",
    "fieldValueIndex": "Alan değeri {{index}}",
    "chooseOptions": "Seçenekleri seç…",
    "chooseEntries": "Kayıtları seç…",
    "unsupportedMultiValueEditor": "Desteklenmeyen çok değerli düzenleyici"
  },
  "graphExplorer": {
    "relationGraph": "İlişki grafiği",
    "entry": "Kayıt",
    "filterGraphByEntry": "Grafiği kayda göre filtrele",
    "all": "Tümü",
    "status": "Durum",
    "graphRelationStatus": "Grafik ilişki durumu",
    "proposedAndConfirmed": "Önerilen ve onaylanan",
    "confirmed": "Onaylanan",
    "proposed": "Önerilen",
    "relation": "İlişki",
    "searchRelationInTheGraph": "Grafikte ilişki ara",
    "filterAtStoryTime": "Hikâye zamanında filtrele",
    "tick": "Tik",
    "graphTick": "Grafik tiki",
    "includeUnknownTime": "Bilinmeyen zamanı dahil et",
    "enterANumericTickOrTurn": "Sayısal bir tik gir ya da zaman filtresini kapat.",
    "navigableRelationGraph": "Gezilebilir ilişki grafiği",
    "selectName": "Seç: {{name}}",
    "entryCount_one": "{{count}} kayıt",
    "entryCount_other": "{{count}} kayıt",
    "relationCount_one": "{{count}} ilişki",
    "relationCount_other": "{{count}} ilişki",
    "hiddenBeyondViewLimit": "{{entries}} ve {{relations}} görünüm sınırının ötesinde.",
    "relationsWithMissingEntries_one": "Eksik kayıtları olan {{count}} ilişki.",
    "relationsWithMissingEntries_other": "Eksik kayıtları olan {{count}} ilişki.",
    "unknownDurationIncluded_one": "Süresi bilinmeyen {{count}} ilişki filtreye dahil.",
    "unknownDurationIncluded_other": "Süresi bilinmeyen {{count}} ilişki filtreye dahil.",
    "unknownDurationExcluded_one": "Süresi bilinmeyen {{count}} ilişki filtre dışında.",
    "unknownDurationExcluded_other": "Süresi bilinmeyen {{count}} ilişki filtre dışında."
  },
  "relationshipPanel": {
    "select": "Seç…",
    "removedReference": "Kaldırılmış başvuru:",
    "projectRelations": "Proje ilişkileri",
    "relationsOf": "İlişkileri:",
    "filterRelationsByEntry": "İlişkileri kayda göre filtrele",
    "allEntries": "Tüm kayıtlar",
    "searchEntries": "Kayıtlarda ara…",
    "searchRelations": "İlişkilerde ara",
    "relationOrEntry": "İlişki ya da kayıt",
    "newRelation": "Yeni ilişki",
    "editRelation": "İlişkiyi düzenle",
    "relationsLinkTwoEntries": "İlişkiler iki kaydı bağlar",
    "addTwoEntriesInTheCodex": "Kodeks'e en az iki kayıt ekle, sonra onları bağlayan sözleri yaz; örneğin “şunun akıl hocasıdır”.",
    "theWorldHasChangedTheFields": "Bu açıkken dünya değişti. Alanların saklandı; yeni verilere karşı kaydetmek için yeniden yükle.",
    "reload": "Yeniden yükle",
    "anEntry": "Bir kayıt",
    "anotherEntry": "Başka bir kayıt",
    "relationSource": "İlişki kaynağı",
    "relationType": "İlişki türü",
    "isTheMentorOf": "şunun akıl hocasıdır",
    "relationTarget": "İlişki hedefi",
    "direction": "Yön",
    "relationDirection": "İlişki yönü",
    "oneWay": "Tek yönlü",
    "bothWays": "Çift yönlü",
    "when": "Ne zaman",
    "relationTime": "İlişki zamanı",
    "notSet": "Ayarlanmamış",
    "betweenTwoMoments": "İki an arasında",
    "fromAnEvent": "Bir olaydan",
    "from": "Başlangıç",
    "to": "bitiş",
    "relationStart": "İlişki başlangıcı",
    "relationEnd": "İlişki bitişi",
    "momentsHint": "Dünyanın zaman çizelgesindeki anlar; bitiş dahil değildir.",
    "event": "Olay",
    "relationEvent": "İlişki olayı",
    "offset": "Fark",
    "relationOffset": "İlişki farkı",
    "offsetHint": "Olaydan sonraki anlar; öncesi için negatif.",
    "status": "Durum",
    "relationStatus": "İlişki durumu",
    "proposed": "Önerilen",
    "confirmed": "Onaylanan",
    "rejected": "Reddedilen",
    "superseded": "Yerine geçilen",
    "confirmedRelationsCountAsCanonIn": "Onaylanan ilişkiler Kontroller'de kanon sayılır.",
    "notes": "Notlar",
    "relationNotes": "İlişki notları",
    "howTheStoryShowsItAnd": "Hikâyenin bunu nasıl gösterdiği ve neyin belirsiz kaldığı.",
    "quotes": "Alıntılar",
    "linkQuotes": "Metinden alıntıları bağla",
    "quotesLinked": "Alıntı sayısı: {{count}}",
    "searchQuotations": "Alıntılarda ara",
    "excerptOrNote": "Alıntı ya da not",
    "removedQuotation": "Kaldırılmış alıntı:",
    "noQuotationYetAnnotateAPassage": "Henüz alıntı yok. Burada anmak için metinde bir pasaja not ekle.",
    "upTo100QuotationsShownUse": "En fazla 100 alıntı gösteriliyor. Listeyi daraltmak için aramayı kullan.",
    "saveRelation": "İlişkiyi kaydet",
    "cancel": "İptal",
    "aDeletedEntry": "silinmiş bir kayıt",
    "aDeletedEvent": "silinmiş bir olay",
    "timeBetween": "{{start}} ile {{end}} arası",
    "timeAtEvent": "Olayda: {{event}}",
    "timeAfterEvent": "{{event}} + {{offset}}",
    "timeBeforeEvent": "{{event}} − {{offset}}",
    "noRelationsYet": "Henüz ilişki yok.",
    "noRelationMatches": "Eşleşen ilişki yok.",
    "edit": "Düzenle",
    "editCaption": "Düzenle: {{caption}}",
    "remove": "Kaldır",
    "removeCaption": "Kaldır: {{caption}}",
    "removeThisRelationTheChangeStays": "Bu ilişki kaldırılsın mı? Değişiklik geçmişte kalır.",
    "confirmRemoval": "Kaldır",
    "shownOfTotal": "{{total}} ilişkiden 100'ü gösteriliyor. Diğerlerini görmek için aramayı daralt.",
    "theWorldHasChangedReloadThe": "Dünya değişti. Kaydetmeden önce ilişkiyi yeniden yükle.",
    "theRelationWasChangedOrRemoved": "İlişki değiştirildi ya da kaldırıldı. Verileri yeniden yükle.",
    "explicitlyConfirmTheRelationBeforeSaving": "Bu ilişkiyi kanon yapmak için yeniden Onaylanan'ı seç.",
    "selectTwoEntriesThatExistIn": "Kodeks'te var olan iki kayıt seç.",
    "fillInTheTimeValuesOr": "Anları doldur ya da Ayarlanmamış'ı seç.",
    "enterAValidIntervalTheEnd": "Bitiş, başlangıçtan sonra gelmeli.",
    "selectAnExistingEventAsThe": "Hâlâ var olan bir olay seç.",
    "theSelectedQuotationIsNoLonger": "Seçilen bir alıntı artık yok.",
    "checkTheRelationTextAndThe": "İlişkinin sözlerini ve notları kontrol et.",
    "theChangeWasNotSavedReload": "Değişiklik kaydedilmedi. Verileri yeniden yükleyip tekrar dene."
  },
  "useWorldReplication": {
    "signInToTheLinkedAccount": "Bağlı hesaba giriş yap ve proje erişimini kontrol et. Yerel değişikliklerin saklandı.",
    "syncTheManuscriptWithThisServer": "Dünyasını bağlamadan önce metni bu sunucuyla senkronize et.",
    "theWorldChangedAfterTheComparison": "Dünya karşılaştırmadan sonra değişti. Güncel kopyaları yeniden gözden geçir.",
    "aConfirmationOrRestoredRecordNeeds": "Bir onay ya da geri yüklenen kayıt, senkronize edilmeden önce açık gözden geçirme gerektirir.",
    "anAttachmentOrRemoteCopyFailed": "Bir ek ya da uzak kopya doğrulamadan geçemedi. Yerel Dünya'n saklandı.",
    "theseChangesExceedASyncLimit": "Bu değişiklikler bir senkronizasyon sınırını aşıyor ya da birlikte uygulanmalı. Yerel Dünya'n ve bekleyen değişiklikler saklandı.",
    "syncPausedYourLocalChangesAre": "Senkronizasyon duraklatıldı. Yerel değişikliklerin saklandı.",
    "newMapNeedsPlan": "Yeni haritalar Ink ve Press ile gelir. Harita bu cihazda kalır ve Dünya bekler: yeniden senkronize etmek için yeni haritayı kaldır ya da bir plan seç.",
    "worldSyncCouldNotFinishCheck": "Dünya senkronizasyonu tamamlanamadı. Bağlantını kontrol edip tekrar dene. Yerel değişikliklerin saklandı."
  },
  "vaultFolders": {
    "folderName": "Klasör: {{name}}",
    "editFolder": "Klasörü düzenle",
    "newSubfolder": "Yeni alt klasör",
    "moveContentsBeforeRemoving": "Kaldırmadan önce içeriği taşı",
    "removeFolder": "Klasörü kaldır",
    "folderActionsName": "Klasör işlemleri: {{name}}",
    "chooseThisFolderWhenEditingA": "Bir sayfayı düzenlerken bu klasörü seç.",
    "projectFolders": "Proje klasörleri",
    "folders": "Klasörler",
    "newFolder": "Yeni klasör",
    "groupPagesFromAnyCollection": "Herhangi bir koleksiyondan sayfaları grupla.",
    "foldersOrganizePagesWithoutChangingTheir": "Klasörler sayfaları koleksiyonunu ya da içeriğini değiştirmeden düzenler.",
    "cancel": "İptal",
    "saveFolder": "Klasörü kaydet",
    "name": "Ad",
    "folderName2": "Klasör adı",
    "inside": "İçinde",
    "parentFolder": "Üst klasör",
    "projectRoot": "Proje kökü",
    "removeEmptyFolder": "Boş klasör kaldırılsın mı?",
    "removeNameFromTheProject": "“{{name}}” projeden kaldırılsın mı?"
  },
  "vaultTable": {
    "unavailableEntry": "Kullanılamayan kayıt",
    "vaultTable": "Kasa tablosu",
    "pages": "Sayfalar",
    "searchVaultTable": "Kasa tablosunda ara",
    "searchPages": "Sayfalarda ara…",
    "tableCollection": "Tablo koleksiyonu",
    "allCollections": "Tüm koleksiyonlar",
    "noCustomCollection": "Özel koleksiyon yok",
    "tableFolder": "Tablo klasörü",
    "allFolders": "Tüm klasörler",
    "unfiled": "Klasörsüz",
    "scrollableVaultTable": "Kaydırılabilir Kasa tablosu",
    "name": "Ad",
    "collection": "Koleksiyon",
    "folder": "Klasör",
    "noPagesMatchTheseFilters": "Bu filtrelerle eşleşen sayfa yok.",
    "none": "Yok",
    "yes": "Evet",
    "no": "Hayır",
    "pagesShown_one": "{{count}} sayfadan {{shown}} tanesi",
    "pagesShown_other": "{{count}} sayfadan {{shown}} tanesi"
  },
  "vaultTree": {
    "blue": "Mavi",
    "emerald": "Zümrüt",
    "gold": "Altın",
    "violet": "Mor",
    "rose": "Gül",
    "amber": "Kehribar",
    "teal": "Camgöbeği",
    "slate": "Arduvaz",
    "crimson": "Kızıl",
    "bark": "Kabuk",
    "forest": "Orman",
    "navy": "Lacivert",
    "orchid": "Orkide",
    "saffron": "Safran",
    "ink": "Mürekkep",
    "ember": "Köz",
    "concept": "Kavram",
    "character": "Karakter",
    "place": "Mekân",
    "faction": "Hizip",
    "object": "Nesne",
    "vault": "Kasa",
    "newCollection": "Yeni koleksiyon",
    "vaultView": "Kasa görünümü",
    "pages": "Sayfalar",
    "table": "Tablo",
    "pagesMarkedUnassignedKeepTheirPrevious": "Atanmamış işaretli sayfalar önceki alanlarını korur. Koleksiyonunu seçmek için bir sayfayı düzenle.",
    "filterPages": "Sayfaları filtrele",
    "filterPages2": "Sayfaları filtrele…",
    "worldVault": "Dünya kasası",
    "removeCollectionName": "Koleksiyonu kaldır: {{name}}",
    "collectionSettingsForName": "Koleksiyon ayarları: {{name}}",
    "iconAndColour": "Simge ve renk",
    "newPageInName": "{{name}} içinde yeni sayfa",
    "noPageYetAddTheFirst": "Henüz sayfa yok — ilkini + ile ekle.",
    "nothingHereYet": "Burada henüz bir şey yok.",
    "removeEmptyCollection": "Boş koleksiyon kaldırılsın mı?",
    "removeNameAndItsSchema": "“{{name}}” ve şeması kaldırılsın mı?",
    "removeCollection": "Koleksiyonu kaldır",
    "text": "Metin",
    "theSvgMustBeUnder16": "SVG 16 KiB'ın altında olmalı.",
    "thisFileIsNotAUsable": "Bu dosya kullanılabilir bir SVG değil (betikler ve dış başvurular kaldırılır; kök <svg> olmalı).",
    "collectionName": "Koleksiyon: {{name}}",
    "sharedFieldsApplyToEveryPage": "Ortak alanlar bu koleksiyondaki her sayfa için geçerlidir. Her sayfanın kendi alanları da olabilir.",
    "cancel": "İptal",
    "saving": "Kaydediliyor…",
    "saveCollection": "Koleksiyonu kaydet",
    "createCollection": "Koleksiyon oluştur",
    "identity": "Kimlik",
    "nameAndIconAsTheTree": "Ağacın ve sayfaların göstereceği şekliyle ad ve simge.",
    "name": "Ad",
    "collectionName2": "Koleksiyon adı",
    "magic": "Sihir",
    "aCollectionWithThisNameAlready": "Bu adla bir koleksiyon zaten var.",
    "icon": "Simge",
    "iconSource": "Simge kaynağı",
    "lucide181": "Lucide (181)",
    "yourSvg": "Senin SVG'n",
    "collectionIcon": "Koleksiyon simgesi",
    "searchLucideIcons": "Lucide simgelerinde ara",
    "searchIconsCastleSwordMoon": "Simge ara — kale, kılıç, ay…",
    "loadingIcons": "Simgeler yükleniyor…",
    "lucideIcon": "Lucide simgesi",
    "noIconMatches": "Eşleşen simge yok.",
    "chooseAnSvgFile": "Bir SVG dosyası seç",
    "customSvgIcon": "Özel SVG simgesi",
    "upTo16KibScriptsLinks": "En fazla 16 KiB. Betikler, bağlantılar ve dış başvurular silinir; koleksiyon renginin uygulanması için dosyada currentColor kullan.",
    "colour": "Renk",
    "aPresetOneYouUsedRecently": "Hazır bir renk, yakın zamanda kullandığın biri ya da çarktan kendi rengin.",
    "collectionColour": "Koleksiyon rengi",
    "recent": "Son kullanılanlar",
    "useHex": "{{hex}} kullan",
    "kindOfPage": "Sayfa türü",
    "everyPageIsACodexEntry": "Her sayfa tek türde bir Kodeks kaydıdır; tür, Kontroller'in, @ anmalarının ve grafiğin onu nasıl ele alacağını belirler ve rengini her yerde korur.",
    "collectionBaseKind": "Koleksiyonun temel türü",
    "magicOrShipsConceptDeitiesOr": "Sihir ya da Gemiler → Kavram · Tanrılar ya da Hanedanlar → Karakter ya da Hizip · kasabalar koleksiyonu → Mekân.",
    "sharedFields": "Ortak alanlar",
    "thePropertiesOfTheCollectionValues": "Koleksiyonun özellikleri — değerler her sayfada durur ve bir sayfa yine de kendi alanını ekleyebilir.",
    "collectionTemplate": "Koleksiyon şablonu",
    "template": "Şablon…",
    "addField": "Alan ekle",
    "exampleMagicLevelNumberRarityChoice": "Örnek: Sihir → Seviye (sayı) · Nadirlik (seçim: yaygın, nadir, efsanevi) · Edinilme (hikâye tarihi) · Öğreten (kayıt bağlantısı).",
    "collectionFieldNameValue": "Koleksiyon alan adı {{value}}",
    "fieldName": "Alan adı",
    "collectionFieldTypeValue": "Koleksiyon alan türü {{value}}",
    "collectionFieldOptionsValue": "Koleksiyon alan seçenekleri {{value}}",
    "optionsOnePerLine": "Seçenekler, her satırda bir tane",
    "required": "Zorunlu",
    "requiredCollectionFieldValue": "Zorunlu koleksiyon alanı {{value}}",
    "removeCollectionFieldValue": "Koleksiyon alanını kaldır: {{value}}",
    "yesNo": "Evet / Hayır",
    "multipleChoice": "Çoktan seçmeli",
    "storyDate": "Hikâye tarihi",
    "entryLink": "Kayıt bağlantısı",
    "multipleEntryLinks": "Birden çok kayıt bağlantısı",
    "fieldParagraph": "Paragraf",
    "fieldNumber": "Sayı",
    "fieldChoice": "Seçim"
  },
  "worldCloudPanel": {
    "worldCloudVersions": "Dünya bulut sürümleri",
    "includesCodexPagesCollectionsFoldersFacts": "Kodeks sayfalarını, koleksiyonları, klasörleri, olguları, ilişkileri ve ekleri içerir. Bir sürümü açıkça yayımla ya da indir. Metin sahne senkronizasyonunu kullanır.",
    "compareVersions": "Sürümleri karşılaştır",
    "recoverPreviousWorld": "Önceki Dünya'yı kurtar…",
    "deviceRevision": "Cihaz revizyonu",
    "accountVersionRemoteversion": "Hesap sürümü {{remoteVersion}}",
    "firstAccountVersion": "İlk hesap sürümü",
    "uploadDeviceVersion": "Cihaz sürümünü yükle…",
    "useAccountVersion": "Hesap sürümünü kullan…",
    "confirmTransfer": "Aktarımı onayla",
    "replaceWorldOnThisDeviceWith": "Bu cihazdaki Dünya bu sürümle değiştirilsin mi? Önce mevcut Dünya'nın ve eklerin bir kopyası saklanır. Metin değişmez.",
    "saveThisCopyToYourAccount": "Bu kopya hesabına kaydedilsin mi? Önceki hesap sürümleri saklanır.",
    "restoreWorldFromBeforeTheLast": "Dünya son aktarımdan önceki haline geri yüklensin mi? Sonraki düzenlemeler bu geri yüklemeyi engeller.",
    "confirm": "Onayla",
    "cancel": "İptal",
    "transferring": "Aktarılıyor…",
    "codexPages": "Kodeks sayfaları",
    "updateStoryideBeforePublishingChangesTo": "Bu Kasa'daki değişiklikleri yayımlamadan önce Musael'i güncelle.",
    "theAccountVersionChangedCompareAgain": "Hesap sürümü değişti. Uygulamadan önce yeniden karşılaştır.",
    "worldChangedOnThisDeviceCompare": "Bu cihazdaki Dünya değişti. Uygulamadan önce yeniden karşılaştır.",
    "accountVersionStorageIsFullPrevious": "Hesap sürümü depolaması dolu. Önceki kopyalar saklandı.",
    "anAttachmentFailedItsIntegrityCheck": "Bir ek bütünlük kontrolünden geçemedi. Hiçbir yerel kopya değiştirilmedi.",
    "theAccountCopyFailedItsIntegrity": "Hesap kopyası bütünlük kontrolünden geçemedi.",
    "noRecoveryCopyIsAvailableFor": "Bu aktarım için kurtarma kopyası yok.",
    "anIdentifierIsAlreadyUsedIn": "Bir tanımlayıcı başka bir projede zaten kullanılıyor.",
    "openOrSyncTheManuscriptWith": "Önce metni aç ya da hesabınla senkronize et.",
    "yourAccountDoesNotHaveThe": "Hesabında gerekli izin yok.",
    "signInAgainThisSessionWas": "Yeniden giriş yap. Bu oturum iptal edildi.",
    "transferCancelled": "Aktarım iptal edildi.",
    "transferFailedCheckYourConnectionAnd": "Aktarım başarısız oldu. Bağlantını kontrol edip yeniden karşılaştır.",
    "couldNotReadTheRecoveryCopy": "Kurtarma kopyası okunamadı.",
    "mondoPrecedenteRipristinato": "Önceki dünya geri yüklendi.",
    "accountVersionVersionSaved": "Hesap sürümü {{version}} kaydedildi.",
    "versionVersionAppliedToWorldOn": "{{version}} sürümü bu cihazdaki Dünya'ya uygulandı.",
    "cancellationRequested": "İptal istendi.",
    "labelFacts": "Olgular",
    "labelEvents": "Olaylar",
    "labelKnowledge": "Bilgi",
    "labelAnnotations": "Ek açıklamalar",
    "labelRelationships": "İlişkiler",
    "labelAttachments": "Ekler",
    "labelCollections": "Koleksiyonlar",
    "labelFolders": "Klasörler",
    "changedCount_one": "{{count}} değişti",
    "changedCount_other": "{{count}} değişti"
  },
  "worldMaps": {
    "character": "Karakter",
    "place": "Mekân",
    "object": "Nesne",
    "faction": "Hizip",
    "concept": "Kavram",
    "pinOf": "İğne: {{name}}",
    "pinMissing": "Eksik bir kaydın iğnesi",
    "missingEntry": "Eksik kayıt",
    "zoom": "Yakınlaştırma",
    "zoomIn": "Yakınlaştır",
    "zoomOut": "Uzaklaştır",
    "fitToView": "Görünüme sığdır",
    "newMap": "Yeni harita",
    "newMapDescription": "Bir yerin resmi; orada bulunan kişiler, yerler ve şeyler için iğneler ekle.",
    "cancel": "İptal",
    "saving": "Kaydediliyor…",
    "createMap": "Harita oluştur",
    "mapOf": "Haritası:",
    "aNewPlace": "Yeni bir yer",
    "placeName": "Yer adı",
    "placeNamePlaceholder": "Tuz Kıyısı",
    "picture": "Resim",
    "choosePicture": "Bir PNG, JPEG, WebP ya da GIF seç",
    "pictureHint": "En fazla 16 MB. Kaydın eklerinden biri olur.",
    "maps": "Haritalar",
    "mapsLead": "Kayıtları yerlerinin resimlerine iğnele. Kendi haritası olan iğnelenmiş bir yer onu açar.",
    "noMapsYet": "Henüz harita yok",
    "noMapsText": "Bir yere resim ver, sonra oraya ait kayıtları iğnele.",
    "addTheFirstMap": "İlk haritayı ekle",
    "onePin": "1 iğne",
    "pins": "{{count}} iğne",
    "inPlace": "{{place}} üzerinde",
    "chooseAnEntryOrName": "Bir kayıt seç ya da iğne için bir ad yaz.",
    "mapTrail": "Bunun üstündeki haritalar",
    "doneAdding": "Bitti",
    "addPin": "İğne ekle",
    "labels": "Etiketler",
    "replacePicture": "Resmi değiştir",
    "removeMap": "Haritayı kaldır",
    "hintClick": "İğnenin gideceği yere haritada tıkla.",
    "hintChoose": "İğnenin neyi gösterdiğini sağdan seç.",
    "pictureMissing": "Bu haritanın resmi henüz bu cihazda yok.",
    "pinDetails": "İğne ayrıntıları",
    "newPin": "Yeni iğne",
    "entry": "Kayıt",
    "chooseAnEntry": "Bir kayıt seç",
    "noEntryLabelOnly": "Kayıt yok, yalnızca etiket",
    "labelOnTheMap": "Haritadaki etiket",
    "labelDefault": "Kaydın adı",
    "labelRequired": "Kayıt yoksa gerekli",
    "placePin": "İğneyi yerleştir",
    "label": "Etiket",
    "openEntry": "Kaydı aç",
    "openItsMap": "Haritasını aç",
    "position": "%{{x}} sağa, %{{y}} aşağı",
    "removePin": "İğneyi kaldır",
    "noPinsYet": "Henüz iğne yok. İğne ekle'yi kullan, sonra haritaya tıkla.",
    "shownOn": "Gösterildiği yer",
    "openEntryOf": "Aç: {{name}}",
    "removeMapTitle": "{{name}} haritası kaldırılsın mı?",
    "removeMapMessage": "İğneler de gider. Resim, kaydın eklerinde kalır."
  },
  "worldPanel": {
    "checks": "Kontroller",
    "findAndFixConsistencyIssuesIn": "Dünyanın olguları, olayları ve ilişkileri metinle karşılaştırılır. YZ yok.",
    "running": "Çalışıyor…",
    "runChecks": "Kontrolleri çalıştır",
    "lastRunAt": "Son çalıştırma: {{time}}",
    "oneAtATime": "Aynı anda tek",
    "exclusiveRelation": "Dışlayıcı ilişki",
    "noRelationIsExclusive": "Hiçbir ilişki dışlayıcı değil",
    "exclusivityType": "Dışlayıcılık türü",
    "oneSourcePerTarget": "Her hedef için bir kaynak",
    "oneTargetPerSource": "Her kaynak için bir hedef",
    "oneAtATimeHint": "Aynı anda yalnızca bir kişi için geçerli olabilen bir ilişki, örneğin “sahibidir”: aynı şeyin aynı anlarda iki sahibi olması çakışma sayılır.",
    "rulesNeedRelations": "Kurallar ilişkilerini kullanır. Bağlantılar'da “sahibidir” gibi bir tane ekle, sonra burada dışlayıcı yap.",
    "results": "Sonuçlar",
    "whatTheChecksLookFor": "Kontrollerin baktığı şeyler",
    "twoHoldersAtOnce": "Aynı anda iki sahip",
    "eventsOutOfOrder": "Sırası bozuk olaylar",
    "quotedPastItsLimit": "Sınırını aşan alıntı",
    "linksToDeletedEntries": "Silinmiş kayıtlara bağlantılar",
    "notesThatLostTheirPlace": "Yerini kaybeden notlar",
    "relationsOverTime": "Zaman içinde ilişkiler",
    "scopeOwnership": "Onaylı olgulardan, aynı anlarda iki kayıt tarafından tutulan tek bir şey.",
    "scopeFlashback": "Dünyada daha sonra gerçekleşen bir olaydan sonra okunan olay: bir geri dönüş ya da bir hata.",
    "scopeReveal": "Bir olgunun, ona izin verdiğin son sahneden sonraki bir sahnede alıntılanması.",
    "scopeOrphans": "Artık var olmayan bir kayda ya da Kütüphane kartına işaret eden notlar ve olgular.",
    "scopeAnchors": "Sözcükleri sahnesinde kayan ya da değişen alıntılanmış bir pasaj.",
    "scopeRelations": "Yukarıdaki kurala karşı ve andıkları alıntılara karşı ilişkiler.",
    "filterResults": "Sonuçları filtrele",
    "all": "Tümü",
    "conflicts": "Çakışmalar",
    "warnings": "Uyarılar",
    "needsData": "Veri gerekiyor",
    "noIssuesFound": "Sorun bulunmadı",
    "theExecutedRulesFoundNoViolation": "Belirlediğin olguları ve kuralları bozan bir şey yok. Kontroller yalnızca kaydettiklerini bilir.",
    "notEnoughData": "Yeterli veri yok",
    "quotesInTheText": "Metindeki alıntılar",
    "anchorInPlace": "Yerinde",
    "anchorMoved": "Taşındı",
    "anchorGone": "Kayıp",
    "reAnchor": "Yeniden bağla",
    "openScene": "Sahneyi aç",
    "checkedAt": "Kontrol zamanı: {{time}}.",
    "twoHold": "{{a}} ve {{b}} aynı anda “{{object}}” tutuyor.",
    "heldTwice": "{{a}}, “{{object}}” nesnesini aynı anlarda iki kez tutuyor.",
    "flashbackSentence": "“{{earlier}}” dünyada “{{later}}” olayından önce gerçekleşiyor ama ondan sonra okunuyor: bilerek yapılmadıysa bir geri dönüş.",
    "revealSentence": "“{{fact}}”, {{scene}} sahnesinde, ona izin verdiğin son sahneden sonra alıntılanıyor.",
    "allowedUpToScene": "Şu sahneye kadar izinli: {{scene}}",
    "orphanFactSentence": "Bir olgu (“{{fact}}”) silinmiş bir kayıt hakkında.",
    "orphanNoteSentence": "“{{excerpt}}” üzerindeki not silinmiş bir kayda işaret ediyor.",
    "orphanConceptSentence": "“{{excerpt}}” üzerindeki not artık var olmayan bir Kütüphane kartına işaret ediyor.",
    "movedSentence": "“{{excerpt}}”, {{scene}} sahnesinde taşındı: notun onu takip etmesi için yeniden bağla.",
    "eventWithoutTime": "“{{title}}” olayının dünyada zamanı yok, bu yüzden sırası kontrol edilemez.",
    "factWithoutTime": "“{{fact}}” olgusunun zaman aralığı yok, bu yüzden sahibi kontrol edilemez.",
    "recordWithoutTime": "Bir kaydın zamanı yok, bu yüzden kontrol edilemez.",
    "aDeletedEntry": "silinmiş bir kayıt",
    "aDeletedEvent": "silinmiş bir olay",
    "aScene": "bir sahne",
    "fromTo": "{{start}} ile {{end}} arası",
    "relativeToAnEvent": "Bir olaya göre",
    "timeNotSet": "Ayarlanmamış",
    "facts": "Olgular",
    "factsLead": "Her kayıt hakkında belirttiklerin. Kontroller onayladıklarını okur ve metinle karşılaştırır.",
    "entries": "Kayıtlar",
    "addAnEntry": "Kayıt ekle",
    "addTheFirstEntry": "İlk kaydı ekle",
    "newEntityName": "Yeni varlık adı",
    "entityType": "Varlık türü",
    "addEntity": "Varlık ekle",
    "character": "Karakter",
    "place": "Mekân",
    "object": "Nesne",
    "faction": "Hizip",
    "other": "Diğer",
    "deleteEntityReferencesBecomeOrphaned": "Varlığı sil (başvurular sahipsiz kalır)",
    "deleteEntityName": "Varlığı sil: {{name}}",
    "noFactYet": "{{name}} hakkında henüz olgu yok. Yeni bir olgu önerilen olarak başlar; sayılması için onayla.",
    "proposed": "Önerilen",
    "confirmed": "Onaylanan",
    "rejected": "Reddedilen",
    "superseded": "Yerine geçilen",
    "worldFact": "Dünya olgusu",
    "characterBelief": "İnanç",
    "testimony": "Tanıklık",
    "authorHypothesis": "Hipotez",
    "confirm": "Onayla",
    "confirmExplicitApproval": "Onayla (açık onay)",
    "newFactAbout": "{{name}} hakkında yeni olgu",
    "predicatePlaceholder": "sahibidir",
    "predicate": "Yüklem",
    "valuePlaceholder": "kılıç",
    "value": "Değer",
    "kind": "Tür",
    "epistemicKind": "Bilgi türü",
    "kindHint": "Yalnızca dünya olguları gerçek sayılır; inançlar, tanıklıklar ve hipotezler saklanır ama kanon olarak kontrol edilmez.",
    "when": "Ne zaman",
    "timeKind": "Zaman türü",
    "betweenTwoMoments": "İki an arasında",
    "from": "Başlangıç",
    "to": "bitiş",
    "startTick": "Başlangıç tiki",
    "endTick": "Bitiş tiki",
    "momentsHint": "Dünyanın zaman çizelgesindeki anlar; bitiş dahil değildir.",
    "reveal": "Ele verme",
    "maximumRevealNarrativeIndex": "En geç ele verme (anlatı sırası)",
    "noLimit": "Sınır yok",
    "sceneNumbered": "{{n}}. {{title}}",
    "revealHint": "Bu olgunun sonraki bir sahnedeki alıntıları işaretlenir.",
    "addFactProposed": "Önerilen olarak ekle",
    "selectAnEntityToSeeAnd": "Olgularını görmek ve eklemek için bir kayıt seç.",
    "noEntityYet": "Henüz kayıt yok. Yukarıdan ya da Kodeks'ten bir karakter, mekân ya da nesne ekle.",
    "resultDetails": "Sonuç ayrıntıları",
    "conflict": "Çakışma",
    "warning": "Uyarı",
    "whatWasCompared": "Neyin karşılaştırıldığı",
    "whatToDo": "Ne yapmalı",
    "comparedOwnership": "Zaman aralığı olan onaylı dünya olguları. Aynı şeyin iki sahibi örtüşemez.",
    "comparedFlashback": "Her olayın dünyadaki zamanı, sahnesinin kitaptaki sırasına karşı.",
    "comparedReveal": "Bir olgu için izin verdiğin son sahne, onu alıntılayan sahnelere karşı.",
    "comparedOrphans": "Her not ve olgu, var olan kayıtlara ve Kütüphane kartlarına karşı.",
    "comparedAnchors": "Her notun alıntısı, sahnenin güncel metnine karşı.",
    "confirmOnlyOneOwnerInThe": "O anlar için tek bir sahip bırak: zaman aralıklarından birini daralt ya da bir olguyu tekrar önerilen yap.",
    "ifTheSceneIsADeliberate": "Sahne bilinçli bir geri dönüşse bırak. Değilse sahneyi taşı ya da olayın zamanını değiştir.",
    "raiseTheMaximumRevealSceneOf": "Olgu için daha geç bir sahneye izin ver ya da alıntıyı öne taşı.",
    "restoreTheMissingEntityFromThe": "Kaydı Kodeks geçmişinden geri yükle ya da ona işaret eden notu ya da olguyu sil.",
    "useReAnchorManualOnThe": "Sonuçlarda alıntıda Yeniden bağla'yı kullan ya da sahneyi açıp pasajı yeniden seç.",
    "giveTheEventOrFactAn": "Ona dünyada bir zaman ver ya da zamansız bırak: kontrol tahmin etmek yerine sessiz kalır.",
    "selectAResult": "Bir sonuç seç",
    "detailsConstraintsAndSuggestedFixesAppear": "Neyin karşılaştırıldığı ve ne yapılacağı burada görünür.",
    "thisAnnotationCannotBeReAnchored": "Bu not yeniden bağlanamaz: “{{excerpt}}” sahnede yok ya da birden fazla geçiyor.",
    "revisionTools": "Düzeltme araçları",
    "loadingRevisionTools": "Düzeltme araçları yükleniyor…"
  },
  "worldReplicationPanel": {
    "theContentChangedWhileItWas": "İçerik onaylanırken değişti. Gözden geçirdiğin içeriği ve onayı seç.",
    "theseChangesCannotBeCombinedInto": "Bu değişiklikler geçerli bir Dünya'da birleştirilemez. Saklanacak tam sürümü seç; iki kopya da kurtarmada kalır.",
    "thisDevice": "Bu cihaz",
    "yourAccount": "Hesabın",
    "viewWorld": "Dünya'yı gör",
    "previousSharedValue": "Önceki ortak değer",
    "theActionCouldNotFinishYour": "İşlem tamamlanamadı. Yerel değişikliklerin saklandı.",
    "worldSync": "Dünya senkronizasyonu",
    "syncCodexPagesFactsTimelinesCollections": "Kodeks sayfalarını, olguları, zaman çizelgelerini, koleksiyonları ve ekleri cihazlar arasında senkronize et. Notlar ve eskizler aşağıda kendi başına senkronize olur.",
    "syncWorldAutomatically": "Dünya'yı otomatik senkronize et",
    "n1PendingChange": "1 bekleyen değişiklik",
    "pendingPendingChanges": "{{pending}} bekleyen değişiklik",
    "syncNow": "Şimdi senkronize et",
    "exportRecoveryCopies": "Kurtarma kopyalarını dışa aktar",
    "compareBeforeSyncing": "Senkronize etmeden önce karşılaştır",
    "signInToTheLinkedAccount": "Senkronize etmek için bağlı hesaba giriş yap. Yerel değişiklikler kayıtlı kalır.",
    "signInToCompareYourWorld": "Dünya'nı karşılaştırmak ve senkronizasyonu açmak için giriş yap.",
    "chooseYourStartingWorld": "Başlangıç Dünya'nı seç",
    "bothCopiesHaveTheSameContent": "İki kopyanın içeriği aynı.",
    "keepTheWorldOnThisDevice": "Bu cihazdaki Dünya'yı koru ya da hesabındaki kopyayı kullan. Önceki yerel Dünya ve ekler kurtarmada saklanır.",
    "keepThisDeviceSync": "Bu cihazı koru ve senkronize et",
    "useAccountCopySync": "Hesap kopyasını kullan ve senkronize et",
    "cancel": "İptal",
    "reviewConcurrentChanges": "Eşzamanlı değişiklikleri gözden geçir",
    "chooseEachValueToKeepOther": "Saklanacak her değeri seç. Diğer değişiklikler otomatik birleşir. İki sürüm de kurtarılabilir kalır.",
    "applyReviewedChoices": "Gözden geçirilen seçimleri uygula",
    "syncingWorldAndAttachments": "Dünya ve ekler senkronize ediliyor…",
    "codexPages": "Kodeks sayfaları",
    "onThisDevice": "Bu cihazda",
    "waitingToSync": "Senkronizasyon bekleniyor",
    "syncing": "Senkronize ediliyor…",
    "upToDate": "Güncel",
    "reviewNeeded": "Gözden geçirme gerekiyor",
    "emptyText": "(boş metin)",
    "emptyList": "(boş liste)",
    "worldStructure": "Dünya yapısı",
    "labelFacts": "Olgular",
    "labelEvents": "Olaylar",
    "labelKnowledge": "Bilgi",
    "labelAnnotations": "Ek açıklamalar",
    "labelRelationships": "İlişkiler",
    "labelAttachments": "Ekler",
    "labelCollections": "Koleksiyonlar",
    "labelFolders": "Klasörler",
    "paused": "Duraklatıldı",
    "addedCount_one": "{{count}} eklendi",
    "addedCount_other": "{{count}} eklendi",
    "removedCount_one": "{{count}} kaldırıldı",
    "removedCount_other": "{{count}} kaldırıldı",
    "changedCount_one": "{{count}} değişti",
    "changedCount_other": "{{count}} değişti",
    "removedValue": "Kaldırıldı",
    "emptyValue": "Boş"
  },
  "worldReviewTools": {
    "deletedEntry": "Silinmiş kayıt",
    "timeUnknown": "Zaman bilinmiyor",
    "storyTimeInterval": "Hikâye zamanı aralığı",
    "relativeToEventPreserved": "Olaya göre (korundu)",
    "from": "Başlangıç",
    "until": "Bitiş",
    "characterKnowledge": "Karakterin bildikleri",
    "couldNotCheckTheSavedManuscriptRetry": "Kayıtlı metin kontrol edilemedi. Tekrar dene.",
    "revisionTools": "Düzeltme araçları",
    "changeImpact": "Değişiklik etkisi",
    "whatPointsToThisRecord": "Bu kayda ne işaret ediyor?",
    "explicitLinksOnlyIncludingIndirectLinksChangingARecord": "Yalnızca açık bağlantılar, dolaylı bağlantılar dahil. Bir kaydı değiştirmek ona bağlı olanları yeniden yazmaz.",
    "impactRecord": "Etki kaydı",
    "chooseARecord": "Bir kayıt seç",
    "linkedRecordsWorldRevision": "bağlı kayıt · Dünya revizyonu",
    "directLink": "Doğrudan bağlantı",
    "missingSourceScene": "Kaynak sahne eksik",
    "noExplicitRecordLinksToThisEntryUnlinkedProse": "Bu kayda açık bir kayıt bağlantısı yok. Bağlantısız düzyazı bu kontrolün dışındadır.",
    "whenDidTheyLearnIt": "Bunu ne zaman öğrendi?",
    "recordAcquisitionAndUseOnTheSameStoryTime": "Edinmeyi ve kullanımı aynı hikâye zamanı ekseninde kaydet. Tahminler ve inançlar ayrı kalır; bölüm sırası asla hikâye zamanı sayılmaz.",
    "recordKnowledge": "Bilgiyi kaydet",
    "couldNotSaveCheckTheIntervalsOrCancelAnd": "Kaydedilemedi. Aralıkları kontrol et ya da Dünya değiştiyse iptal edip yeniden aç.",
    "character": "Karakter",
    "knowledgeCharacter": "Bilen karakter",
    "chooseACharacter": "Bir karakter seç",
    "fact": "Olgu",
    "knowledgeFact": "Bilinen olgu",
    "chooseAConfirmedWorldFact": "Onaylı bir dünya olgusu seç",
    "acquired": "Edinildi",
    "acquisitionSource": "Edinme kaynağı",
    "noSourceAttached": "Kaynak eklenmedi",
    "use": "Kullanım",
    "scene": "Sahne",
    "chooseAScene": "Bir sahne seç",
    "knownInformation": "Bilinen bilgi",
    "belief": "İnanç",
    "guess": "Tahmin",
    "passageSource": "Pasaj kaynağı",
    "noPassageAttached": "Pasaj eklenmedi",
    "removeUse": "Kullanımı kaldır",
    "addUse": "Kullanım ekle",
    "confirmAndSave": "Onayla ve kaydet",
    "cancel": "İptal",
    "missingFact": "Eksik olgu",
    "atUnknownRelativeTime": "bilinmeyen/göreli zamanda",
    "edit": "Düzenle",
    "couldNotRemoveTheRecordRefreshAndRetry": "Kayıt kaldırılamadı. Yenileyip tekrar dene.",
    "checkSavedKnowledge": "Kayıtlı bilgiyi kontrol et",
    "theWorldChangedSinceThisResultRunTheCheck": "Dünya bu sonuçtan sonra değişti. Kontrolü yeniden çalıştır.",
    "recordedUseIsEarlierThanAcquisition": "Kaydedilen kullanım edinmeden önce",
    "recordedTimesAreInOrder": "Kaydedilen zamanlar sırayla",
    "beliefOrGuessNotAKnowledgeConflict": "İnanç ya da tahmin — bilgi çakışması değil",
    "notEnoughInformationToCompare": "Karşılaştırmak için yeterli bilgi yok",
    "attachedPassagesMatchTheSavedText": "Eklenen pasajlar kayıtlı metinle eşleşiyor",
    "aSourceIsMissingStaleOrBelongsToAnother": "Bir kaynak eksik, eskimiş ya da başka bir sahneye ait",
    "authorRecordedTimesPassagesAreNotVerified": "Yazarın kaydettiği zamanlar; pasajlar doğrulanmadı",
    "openScene": "Sahneyi aç",
    "noConfirmedKnowledgeUsesToCompare": "Karşılaştırılacak onaylı bilgi kullanımı yok.",
    "openNamedScene": "Aç: {{title}}",
    "recordSummary": "Kullanım: {{count}} · {{lifecycle}} · Edinme: {{time}}",
    "checkSummary": "Kontrol zamanı: {{time}} · {{count}} kayıtlı kullanım. Düzyazıyı düzenledikten sonra yenile.",
    "resultsLimitedTo500Records": "Sonuçlar 500 kayıtla sınırlı",
    "linksAway": "{{depth}} bağlantı uzakta",
    "useNKind": "Kullanım {{n}} türü",
    "useN": "Kullanım {{n}}",
    "useNSource": "Kullanım {{n}} kaynağı",
    "checking": "Denetleniyor…"
  },
  "worldSection": {
    "overview": "Genel bakış",
    "vault": "Kasa",
    "timeline": "Zaman çizelgesi",
    "connections": "Bağlantılar",
    "references": "Başvurular",
    "checks": "Kontroller",
    "analysis": "Analiz",
    "characters": "Karakterler",
    "locations": "Mekânlar",
    "factions": "Hizipler",
    "objects": "Nesneler",
    "concepts": "Kavramlar",
    "worldViews": "Dünya görünümleri",
    "world": "Dünya",
    "browseByType": "Türe göre gözat",
    "filterByType": "Türe göre filtrele",
    "all": "Tümü",
    "newEntry": "Yeni kayıt",
    "cercaNelCodex": "Kodeks'te ara",
    "searchEntries": "Kayıtlarda ara…",
    "entry": "kayıt",
    "entries": "kayıt",
    "alsoAliases": "Ayrıca: {{aliases}}",
    "noEntriesYetCreateTheFirst": "Henüz kayıt yok. İlk karakteri, mekânı ya da hizbi oluştur.",
    "noEntryMatches": "Eşleşen kayıt yok.",
    "editName": "Düzenle: {{name}}",
    "edit": "Düzenle",
    "archive": "Arşivle",
    "confirmArchive": "Arşivlemeyi onayla",
    "notesAndSketches": "Notlar ve eskizler",
    "alsoKnownAs": "Diğer adıyla",
    "addADescriptionOneLineThat": "Bir açıklama ekle — bunun ne olduğunu söyleyen tek bir satır.",
    "none": "Yok",
    "yes": "Evet",
    "no": "Hayır",
    "removedEntry": "Kaldırılmış kayıt",
    "unavailableEntry": "Kullanılamayan kayıt",
    "noNotesYetEditTheEntry": "Henüz not yok. Tanımlamak için kaydı düzenle.",
    "linkedScenes": "Bağlı sahneler",
    "showTheEntriesOfABook": "Bir kitabın kayıtlarını göster",
    "allBooks": "Tüm kitaplar",
    "bookLine": "Kitap {{number}} · {{title}}",
    "inNoBookYet": "Henüz hiçbir kitapta yok",
    "scenesThatMentionThisEntryBy": "Bu kayıttan adıyla ya da takma adıyla söz eden sahneler burada görünür.",
    "facts": "Olgular",
    "noFactRecordedFactsAreAdded": "Kayıtlı olgu yok. Olgular Kontroller'de eklenir ve onaylanır.",
    "relations": "İlişkiler",
    "noRelationYet": "Henüz ilişki yok.",
    "proposed": " · önerilen",
    "viewAll": "Tümünü gör",
    "attachments": "Ekler",
    "attachAnImageToUseIt": "Portre olarak kullanmak için bir görsel ekle.",
    "kib": "KiB",
    "open": "Aç",
    "remove": "Kaldır",
    "addAttachment": "Ek ekle",
    "stateAtStoryTime": "Hikâye zamanındaki durum",
    "tick": "Tik",
    "factsWithoutACompleteInterval": "tam aralığı olmayan olgu.",
    "selectAnEntry": "Bir kayıt seç",
    "charactersPlacesFactionsAndObjectsLive": "Karakterler, mekânlar, hizipler ve nesneler burada; olguları, ilişkileri ve ekleriyle birlikte.",
    "recentChanges": "Son değişiklikler",
    "undoChange": "Değişikliği geri al",
    "worldTimeline": "Dünya zaman çizelgesi",
    "eventsPeopleAndPlacesInA": "Daha geniş bir bağlamda olaylar, kişiler ve mekânlar.",
    "noEventYet": "Henüz olay yok",
    "addTheFirstEventWithA": "İlk olayı bir hikâye zamanıyla ekle ya da bilene kadar zamanı bilinmeyen bırak.",
    "tick2": "tik",
    "plotEvent": "Olay örgüsü olayı",
    "worldEvent": "Dünya olayı",
    "openScene": "Sahneyi aç",
    "unknownTime": "Bilinmeyen zaman",
    "unknown": "bilinmiyor",
    "seeHowYourWorldSPeople": "Dünyandaki kişilerin, mekânların ve fikirlerin nasıl bağlandığını gör.",
    "connectionsView": "Bağlantılar görünümü",
    "graph": "Grafik",
    "list": "Liste",
    "nothingToConnectYet": "Henüz bağlanacak bir şey yok",
    "createEntriesInTheCodexAnd": "Kodeks'te kayıtlar oluştur ve Liste görünümünde ilişkilendir.",
    "selectedEntry": "Seçili kayıt",
    "relationSummary": "İlişki özeti",
    "noSceneMentionsThisEntryYet": "Henüz hiçbir sahne bu kayıttan söz etmiyor.",
    "openInCodex": "Kodeks'te aç",
    "selectANodeToSeeIts": "İlişkilerini ve sahnelerini görmek için bir düğüm seç.",
    "annotationsAnchoredInTheManuscriptAnd": "Metne bağlanan ek açıklamalar ve dünyan için tuttuğun dosyalar.",
    "addFile": "Dosya ekle",
    "annotations": "Ek açıklamalar",
    "selectTextInTheManuscriptAnd": "Metinde bir yer seç ve bir anlatım tekniğini, bir varlığı ya da bir notu bağlamak için “Not ekle”yi kullan.",
    "scene": "Sahne",
    "device": "Anlatım tekniği",
    "entity": "Varlık",
    "note": "Not",
    "imagesPdfsNotesAndAudioYou": "Dünyaya ya da bir kayda eklediğin görseller, PDF'ler, notlar ve ses.",
    "linked": "Bağlı",
    "orphan": "Sahipsiz",
    "openFile": "Dosyayı aç",
    "referenceDetails": "Başvuru ayrıntıları",
    "textAnnotation": "Metin ek açıklaması",
    "kind": "Tür",
    "anchor": "Bağ",
    "concept": "Kavram",
    "created": "Oluşturuldu",
    "anchorStatesValidStaleOrphanedAnd": "Bağ durumları (geçerli, eskimiş, sahipsiz) ve yeniden bağlama Kontroller'de hesaplanır.",
    "attachment": "Ek",
    "type": "Tür",
    "size": "Boyut",
    "linkedTo": "Bağlı olduğu öğe",
    "added": "Eklendi",
    "confirmRemove": "Kaldırmayı onayla",
    "selectAnAnnotationOrAFile": "Bir ek açıklama ya da dosya seç.",
    "exploreTheShapeOfYourStory": "Hikâyenin biçimini keşfet: sahneler boyunca uzunluk, varlık ve yoğunluk.",
    "sceneLength": "Sahne uzunluğu",
    "wordsPerScene": "Sahne başına kelime",
    "noScenesYet": "Henüz sahne yok.",
    "titleFmtWords": "{{title}}: {{fmt}} kelime",
    "entityDensity": "Varlık yoğunluğu",
    "codexMentionsPerScene": "Sahne başına Kodeks anmaları",
    "titleMentionsMentions": "{{title}}: {{mentions}} anma",
    "characterAppearanceMap": "Karakter görünüm haritası",
    "aDotWhereACharacterIs": "Bir karakterin bir sahnede anıldığı yerde bir nokta",
    "addCharactersToTheCodexAnd": "Kodeks'e karakterler ekle ve sahnelerde adlarını an.",
    "thisScene": "Bu sahne",
    "words": "Kelime",
    "paragraphs": "Paragraf",
    "sentencesEst": "Cümle (tah.)",
    "distinctWords": "Farklı kelime",
    "annotatedDevices": "Notlu anlatım teknikleri",
    "n1000Words": "/ 1.000 kelime",
    "repetitions": "Tekrarlar",
    "exportHtml": "HTML dışa aktar",
    "exportTxt": "TXT dışa aktar",
    "events": "Olaylar",
    "confirmedFacts": "Onaylı olgular",
    "recentlyChanged": "Yakın zamanda değişen",
    "changesToTheWorldWillBe": "Dünyadaki değişiklikler burada, her biri geri alma ile listelenir.",
    "undo": "Geri al",
    "startHere": "Buradan başla",
    "overviewEmptyLead": "Hikâyenin kişileri, mekânları ve olayları, göründükleri sahnelere bağlı.",
    "addACharacter": "Karakter ekle",
    "addACharacterText": "Kim olduğu, ne istediği ve önünde ne durduğu.",
    "addAPlace": "Mekân ekle",
    "addAPlaceText": "Sahnelerin geçtiği yer: bir şehir, bir gemi, tek bir oda.",
    "addAnEventText": "Hikâyede gerçekleşen bir şey; tarihiyle ya da tarihsiz.",
    "inThisWorld": "Bu dünyada",
    "createAnEntry": "Kayıt oluştur",
    "aCharacterAPlaceAFaction": "Bir karakter, mekân, hizip, nesne ya da kavram.",
    "addAnEvent": "Olay ekle",
    "withAnExactStoryTimeOr": "Kesin bir hikâye zamanıyla ya da bilinmeyen bir zamanla.",
    "runTheChecks": "Kontrolleri çalıştır",
    "deterministicRulesOwnershipOrderAnchorsOrphans": "Sahipler, sıra, ele vermeler ve zaman içinde ilişkiler, metinle karşılaştırılır.",
    "loadingTheWorld": "Dünya yükleniyor…",
    "maps": "Haritalar",
    "openItsMap": "Haritasını aç",
    "addAMap": "Harita ekle",
    "pinnedOn": "Üzerine iğnelendi",
    "typeCharacter": "Karakter",
    "typeLocation": "Konum",
    "typeObject": "Nesne",
    "typeFaction": "Hizip",
    "typeConcept": "Kavram",
    "annotationsToReAnchor_one": "Yeniden sabitlenecek {{count}} ek açıklama.",
    "annotationsToReAnchor_other": "Yeniden sabitlenecek {{count}} ek açıklama."
  }
}
